/**
 * Real explore (SIGHT-2217, looker-enterprise PR #521): `explore_bidstream`,
 * model `client_analytics` - same explore as bidstream.ts's summary metrics,
 * via its 14 `failed_*` loss-reason measures.
 *
 * No comparison measure exists, so trend comes from a second query against
 * the equal-length preceding window (see RejectionReasons.findItems),
 * diffed here - same approach as parseBidstreamResponse.
 */
/**
 * Maps each `explore_bidstream_base.failed_*` query field to the canonical
 * reason `field` key smithers already displays (see
 * REJECTION_REASON_LABELS in smithers' rejectionReasons.ts) - most match
 * 1:1; `failed_allowance`/`failed_freq_cap` are the two exceptions, kept as
 * `did_pass_allowance`/`did_pass_freq_cap` to match the UI's existing keys
 * without having to touch its display-label table.
 */
export const REJECTION_REASON_FIELD_MAP = [
    { queryField: "explore_bidstream_base.failed_floor", field: "floor" },
    {
        queryField: "explore_bidstream_base.failed_allowance",
        field: "did_pass_allowance"
    },
    { queryField: "explore_bidstream_base.failed_geo", field: "geo" },
    {
        queryField: "explore_bidstream_base.failed_freq_cap",
        field: "did_pass_freq_cap"
    },
    { queryField: "explore_bidstream_base.failed_segments", field: "segments" },
    { queryField: "explore_bidstream_base.failed_daypart", field: "daypart" },
    {
        queryField: "explore_bidstream_base.failed_media_type",
        field: "media_type"
    },
    { queryField: "explore_bidstream_base.failed_placement", field: "placement" },
    { queryField: "explore_bidstream_base.failed_dealpub", field: "dealpub" },
    { queryField: "explore_bidstream_base.failed_badv", field: "badv" },
    {
        queryField: "explore_bidstream_base.failed_creative_vast",
        field: "creative_vast"
    },
    { queryField: "explore_bidstream_base.failed_bcat", field: "bcat" },
    {
        queryField: "explore_bidstream_base.failed_creative_asset",
        field: "creative_asset"
    },
    { queryField: "explore_bidstream_base.failed_dcat", field: "dcat" }
];
/**
 * `prior` is the same query re-run for the equal-length preceding window.
 * Both are scoped to one lineItemId, so `prior[0]` always matches
 * `current`'s row. Returns [] when there's no current-period row (no bid
 * activity to attribute losses to).
 */
export const parseRejectionReasonsResponse = (current, prior) => {
    const currentEntry = current[0];
    if (!currentEntry)
        return [];
    const priorEntry = prior[0];
    return REJECTION_REASON_FIELD_MAP.map(({ queryField, field }) => ({
        field,
        count: currentEntry[queryField],
        countPriorPeriod: priorEntry?.[queryField] ?? currentEntry[queryField]
    }));
};
//# sourceMappingURL=rejectionReasons.js.map